import { IconType } from '@/types';

export default function MapsPinIcon({ className, width = 24, height = 24 }: IconType) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox='0 0 17 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.5 11.5001C9.47467 11.5001 10.4094 11.1313 11.0986 10.475C11.7878 9.81857 12.175 8.92833 12.175 8.00008C12.175 7.07182 11.7878 6.18158 11.0986 5.5252C10.4094 4.86883 9.47467 4.50008 8.5 4.50008C7.52533 4.50008 6.59058 4.86883 5.90138 5.5252C5.21218 6.18158 4.825 7.07182 4.825 8.00008C4.825 8.92833 5.21218 9.81857 5.90138 10.475C6.59058 11.1313 7.52533 11.5001 8.5 11.5001ZM8.5 6.50008C8.91771 6.50008 9.31832 6.65811 9.61369 6.93942C9.90906 7.22072 10.075 7.60225 10.075 8.00008C10.075 8.3979 9.90906 8.77943 9.61369 9.06074C9.31832 9.34204 8.91771 9.50008 8.5 9.50008C8.08228 9.50008 7.68167 9.34204 7.3863 9.06074C7.09093 8.77943 6.925 8.3979 6.925 8.00008C6.925 7.60225 7.09093 7.22072 7.3863 6.93942C7.68167 6.65811 8.08228 6.50008 8.5 6.50008Z'
        fill='#45464E'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.625 8.123C0.625 12.366 5.2261 19.5 8.5 19.5C11.7739 19.5 16.375 12.366 16.375 8.123C16.375 3.917 12.8533 0.5 8.5 0.5C4.1467 0.5 0.625 3.917 0.625 8.123ZM14.275 8.123C14.275 11.403 10.3427 17.5 8.5 17.5C6.65725 17.5 2.725 11.403 2.725 8.123C2.725 5.013 5.31535 2.5 8.5 2.5C11.6846 2.5 14.275 5.013 14.275 8.123Z'
        fill='#45464E'
      />
    </svg>
  );
}
